import React from 'react';
import Typography from '@material-ui/core/Typography';

const PageNotFound = () => {
	return (
		<div>
			<Typography variant='h4' gutterBottom>
				404
			</Typography>
			<Typography variant='subtitle1' gutterBottom>
				Page not found
			</Typography>
		</div>
	);
};

export default PageNotFound;
